import { firebaseService } from '@/services/firebaseApp'
import { useIsomorphicEffect } from '@codeleap/common'
import { useState } from 'react'

export const useFirebase = () => {
  const [firebase, setFirebase] = useState(() => firebaseService?.instance)

  useIsomorphicEffect(() => {
    if (!firebase) {
      firebaseService.initialize().then(setFirebase).catch(() => null)
    }
  }, [])

  return firebase
}
